import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../../contexts/queryParamsContext";
import { AppSelect } from "../../components/appComponents";
import { respEnum, SearchTypeEnum } from "../../constants/appConstant";

const ClubUsers = () => {
  const [data, setData] = useState({});

  // Filter states
  const [isActive, setIsActive] = useState(null);

  const navigate = useNavigate();
  const { setId } = useQueryParams();

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    getData(1);
  }, [isActive]);

  const resetFilters = () => {
    setIsActive(null);
  };

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null,
    isactive = isActive
  ) => {
    const response = await Common.ApiService.getInstance().request(
      "GetPrivateClubUsers",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        recordsToDisplay,
        isactive: isActive,
      },
      "Post"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          fullPhone: `${item.phoneCode || ""} ${item.phone || ""}`.trim(),
          isactiveText: item.isactive ? "Active" : "Inactive",
        })),
      };
      setData(obj);
    }
  };

  const _handleDelete = async (obj) => {
    const result = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this private user?",
      "This action cannot be undone."
    );

    if (result) {
      let resp = await Common.ApiService.getInstance().request(
        `DeletePrivateUser?id=${obj.id}`,
        {},
        "Delete"
      );
      if (resp.status == respEnum.Success) {
        Common.SweetAlert.alert(resp.message, "success");
        setTimeout(() => {
          getData(1);
        }, 300);
      }
    }
  };

  const _thead = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    { title: "Name", type: "text", isVisible: true, key: "name" },
    { title: "Phone Number", type: "text", isVisible: true, key: "fullPhone" },
    { title: "Street No", type: "text", isVisible: true, key: "streetno" },
    { title: "House No", type: "text", isVisible: true, key: "houseno" },
    { title: "Status", type: "text", isVisible: true, key: "isactiveText" },
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => {
        setId(val.id);
        navigate("/app/addclubuser");
      },
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val),
    },
  ];

  const _addBtn = () => (
    <Button onClick={() => navigate("/app/addclubuser")}>
      <span className="text-xl mr-1">
        <Icon icon="icon-park-outline:plus" />
      </span>
      Add Private User
    </Button>
  );

  return (
    <>
      <div className="md:grid md:grid-cols-5 grid grid-cols-2 gap-x-2 ">
        <AppSelect
          value={isActive}
          onChange={setIsActive}
          placeholder="Select Status"
          label="Status"
          data={[
            { id: null, name: "All" },
            { id: true, name: "Active" },
            { id: false, name: "Inactive" },
          ]}
          className="mb-3 col-span-1"
        />
      </div>

      <div className="md:grid md:grid-cols-5 grid grid-cols-2 gap-x-2 mb-3">
        <Button className="h-8 w-fit" onClick={resetFilters}>
          Reset Filters
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"Private Users"}
          columns={_thead.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={_addBtn}
          showPagination
          showAddButton
          actionButtons={actions}
          search={SearchTypeEnum.Server_Search}
          searchInputClassName="custom-search-mobile "
        />
      )}
    </>
  );
};

export default ClubUsers;
